module.exports = __webpack_public_path__ + "presenter2-13d547ef32a4e4314d3f4185ca03dd59.jpg";